import { doForgotPassword } from 'actions/account'

export function doResetPassword(params) {
  return doForgotPassword(params.emailInput, params.subdomainInput)
}
